import React from 'react';
import store from '../../store/Store';

import actionTypes from '../../actionTypes/actionTypes';
import actions from '../../actions/Actions';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import { Redirect } from 'react-router-dom';

import Navigation from '../navigation/Navigation'
import PageSelection from '../pageSelection/PageSelection'
import EditorContextMenu from '../editorContextMenu/EditorContextMenu'
import EditorInformation from '../editorInformation/EditorInformation'
import EditorModal from '../editorModal/EditorModal'
import EditorMedia from '../editorMedia/EditorMedia'

import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import Icon from "@material-ui/core/Icon";
import IconButton from '@material-ui/core/IconButton';
import MergeTypeIcon from '@material-ui/icons/MergeType';
import VerticalSplitOutlinedIcon from '@material-ui/icons/VerticalSplitOutlined';
import HorizontalSplitOutlinedIcon from '@material-ui/icons/HorizontalSplitOutlined';
import HeightIcon from '@material-ui/icons/Height';
import CloseIcon from '@material-ui/icons/Close';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ImageIcon from '@material-ui/icons/Image';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import NavigationOutlinedIcon from '@material-ui/icons/NavigationOutlined';
import SelectAllIcon from '@material-ui/icons/SelectAll';
import EditIcon from '@material-ui/icons/Edit';
import BorderRightIcon from '@material-ui/icons/BorderRight';
import BorderLeftIcon from '@material-ui/icons/BorderLeft';
import BorderBottomIcon from '@material-ui/icons/BorderBottom';
import BorderTopIcon from '@material-ui/icons/BorderTop';
import BorderOuterIcon from '@material-ui/icons/BorderOuter';
import BorderAllIcon from '@material-ui/icons/BorderAll';
import DashboardIcon from '@material-ui/icons/Dashboard';
import OpenWithIcon from '@material-ui/icons/OpenWith';
import TableChartIcon from '@material-ui/icons/TableChart';
import DescriptionIcon from '@material-ui/icons/Description';
import QueueIcon from '@material-ui/icons/Queue';
import VerticalAlignCenterIcon from '@material-ui/icons/VerticalAlignCenter';
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom';
import VerticalAlignTopIcon from '@material-ui/icons/VerticalAlignTop';
import SaveIcon from '@material-ui/icons/Save';
import SlideshowIcon from '@material-ui/icons/Slideshow';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ViewAgendaOutlinedIcon from '@material-ui/icons/ViewAgendaOutlined';

import './editorTable.scss';

type editorTableState = {
  article: any;
    navigation: any;
    menu: any;
}

type editorTableProps = {
  article: any;
    navigation: any;
}

class EditorTable extends React.Component<editorTableProps, editorTableState> {

  constructor(props) {
    super(props)

    // console.log('constructor')

    this.state = {
      article: props.article,
        navigation: props.navigation,
        menu: store.getState().menu
    }
  }

  componentDidMount() {
    // console.log('componentDidMount')

    const { navigation } = this.state

    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        navigation: store.getState().navigation,
        menu: store.getState().menu
      })
    })

    if (true || navigation.resize.active) {
      // this.addResizer()
    }

    // this.addSelector()
  }

  componentDidUpdate() {
    // console.log('componentDidUpdate')

    const { article, navigation } = this.state

    if (true || navigation.resize.active) {
      this.addResizer()
    }

    this.addSelector()
  }

  shouldComponentUpdate() {
    // console.log('shouldComponentUpdate')
    
    const { article, navigation } = this.state

    // console.log(article.info.currentPage)

    this.removeResizer(article.info.currentPage)
    this.removeSelector(article.info.currentPage)
    
    let value = true
    return value
  }

  getSnapshotBeforeUpdate() {
    // console.log('getSnapshotBeforeUpdate')

    const { article, navigation } = this.state

    // console.log(article.info.currentPage)

    let doc = document
    return doc
  }

  componentWillUnmount() {
    console.log('componentWillUnmount')

    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        navigation: store.getState().navigation
      })
    })
  }

  removeSelector = (previousPage) => {
    // console.log('removeSelector')
    // console.log(previousPage)

    const tables = document.getElementById('table')
    const columns = tables.querySelectorAll('th')
    const rows = tables.querySelectorAll('tr')

    columns.forEach((column, index, array) => {
      if (columns.length === index) {
        // return
      }

      let colSelectorAlreadyExist = column.children.namedItem('colSelector' + previousPage + 'c' + index) ? true : false

      if (colSelectorAlreadyExist) {
        column.removeChild(column.children.namedItem('colSelector' + previousPage + 'c' + index))
      }
    })

    rows.forEach((row, index, array) => {
      if (rows.length === index) {
        // return
      }

      let rowSelectorParent = row.parentElement.parentElement.parentElement
      let rowSelectorAlreadyExist = rowSelectorParent.children.namedItem('rowSelector' + previousPage + 'r' + index) ? true : false

      if (rowSelectorAlreadyExist) {
        // console.log('Removed Row Selector: ' + 'rowSelector' + previousPage + 'r' + index)
        rowSelectorParent.removeChild(rowSelectorParent.children.namedItem('rowSelector' + previousPage + 'r' + index))
      }
    })
  }

  addSelector = () => {
    // console.log('addSelector')

    const { 
      article
    } = this.state

    let navigation = false
    let negativeNavigation = false
    let pageSelection = false
    let negativePageSelection = false
    let spacing = 0
    let spacingMargin = 0

    // console.log('Current Page: ' + article.info.currentPage)

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index ? navigation = page.activeNavigation : null
      article.info.currentPage === page.index ? negativeNavigation = page.activeNegativeNavigation : null
      article.info.currentPage === page.index ? pageSelection = page.activePageSelection : null
      article.info.currentPage === page.index ? negativePageSelection = page.activeNegativePageSelection : null
      article.info.currentPage === page.index ? spacing = page.spacing : null
      article.info.currentPage === page.index ? spacingMargin = page.spacingMargin : null
    })

    const tables = document.getElementById('table')
    const columns = tables.querySelectorAll('th')
    const rows = tables.querySelectorAll('tr')

    columns.forEach((column, index, array) => {

      if (columns.length === index) {
        return
      }

      let colSelectorAlreadyExist = column.children.namedItem('colSelector' + article.info.currentPage + 'c' + index) ? true : false

      if (colSelectorAlreadyExist) {
        // console.log(column.querySelector('colSelector' + article.info.currentPage + 'c' + index))
        column.removeChild(column.children.namedItem('colSelector' + article.info.currentPage + 'c' + index))
      }

      const colSelector = document.createElement('div')
      colSelector.classList.add('colSelector' + article.info.currentPage + 'c' + index)
      colSelector.id = 'colSelector' + article.info.currentPage + 'c' + index
      // colSelector.style.height = navigation && negativeNavigation ? 'calc(100vh - ' + (columns.length * spacing) + 'px - 100px)' : navigation || negativeNavigation ? 'calc(100vh - ' + (columns.length * spacing) + 'px - 50px)' : 'calc(100vh - ' + (columns.length * spacing) + 'px)'
      colSelector.style.height = '10px'
      colSelector.style.position = 'absolute'
      colSelector.style.top = '0'
      colSelector.style.right = '0'
      // colSelector.style.width = '5px'
      colSelector.style.width =  '100%' // navigation && negativeNavigation ? 'calc(' + (columns.length * spacing) + 'px - 100px)' : navigation || negativeNavigation ? 'calc(' + (columns.length * spacing) + 'px - 50px)' : 'calc(' + (columns.length * spacing) + 'px)'
      colSelector.style.cursor = 'grab'
      colSelector.style.userSelect = 'none'
      colSelector.style.zIndex = '1'

      column.appendChild(colSelector)

      this.createSelectableColumn(article.info.currentPage, column, colSelector, index)
    })

    rows.forEach((row, index, array) => {
      if (rows.length === index) {
        return
      }

      let rowSelectorParent = row.parentElement.parentElement.parentElement
      let rowSelectorPosition = row.getBoundingClientRect()

      // console.log(rowSelectorPosition)

      let rowSelectorPositionTop = rowSelectorPosition.top + 'px'
      let rowSelectorPositionBottom = (rowSelectorPosition.top + rowSelectorPosition.height - 3) + 'px'
      let rowSelectorPositionLeft = rowSelectorPosition.left + 'px'
      let rowSelectorPositionWidth = 0
      let rowSelectorPositionHeight = rowSelectorPosition.height + 'px'

      // console.log('--- --- ---')
      // console.log(rowSelectorPosition)
      // console.log(rowSelectorPositionTop)
      // console.log(rowSelectorPositionBottom)
      // console.log(rowSelectorPositionLeft)
      // console.log(rowSelectorPositionWidth)
      // console.log(rowSelectorPositionHeight)

      let rowSelectorAlreadyExist = rowSelectorParent.children.namedItem('rowSelector' + article.info.currentPage + 'r' + index) ? true : false

      if (rowSelectorAlreadyExist) {
        // console.log(row.querySelector('rowSelector' + article.info.currentPage + 'r' + index))
        rowSelectorParent.removeChild(rowSelectorParent.children.namedItem('rowSelector' + article.info.currentPage + 'r' + index))
      }

      const rowSelector = document.createElement('div')
      rowSelector.classList.add('rowSelector' + article.info.currentPage + 'r' + index)
      rowSelector.id = 'rowSelector' + article.info.currentPage + 'r' + index
      rowSelector.style.height = rowSelectorPositionHeight // rowSelectorPositionHeight
      rowSelector.style.position = 'absolute'
      // rowSelector.style.bottom = '0'
      rowSelector.style.top = rowSelectorPositionTop // rowSelectorPositionBottom
      // rowSelector.style.left = '0'
      rowSelector.style.left = rowSelectorPositionLeft
      rowSelector.style.width = '10px' // spacingMargin && pageSelection && negativePageSelection ? 'calc(100vw - 100px)' : pageSelection && negativePageSelection ? 'calc(100vw - 100px)' : spacingMargin && pageSelection ? 'calc(100vw - 50px)' : spacingMargin && negativePageSelection ? 'calc(100vw - 50px)' : spacingMargin ? '100vw' : pageSelection ? 'calc(100vw - ' + (rows.length * spacing) + 'px - 50px)' : negativePageSelection ? 'calc(100vw - ' + (rows.length * spacing) + 'px - 50px)' : 'calc(100vw - ' + (rows.length * spacing) + 'px)'
      rowSelector.style.cursor = 'grab'
      rowSelector.style.userSelect = 'none'

      rowSelectorParent.appendChild(rowSelector)

      this.createSelectableRow(article.info.currentPage, row, rowSelector, index)
    })
  }

  createSelectableColumn = (currentPage, column, colSelector, index) => {
    // console.log('Col: ' + column)
    // console.log('Selector: ' + colSelector)
    // console.log('Index: ' + index)
    // console.log('Current Page: ' + currentPage)

    let width = 0
    let mouseDown = 0
    let mouseMoved = 0

    // console.log(mouseDown)
    // console.log(mouseMoved)

    const colMouseDownHandler = (event) => {
      mouseDown = event.clientX

      const styles = window.getComputedStyle(column)
      width = parseInt(styles.width, 10)

      document.addEventListener('mousemove', columnMouseMoveHandler, false)
      document.addEventListener('mouseup', columnMouseUpHandler, false)

      colSelector.classList.add('selecting')

      console.log('Column Mouse Down Select')
    }

    const columnMouseMoveHandler = (event) => {
      // column.style.width = (width + (event.clientX - mouseDown)) + 'px'

      console.log('Column Mouse Move Select')
    }

    const columnMouseUpHandler = (event) => {
      const { article } = this.state

      document.removeEventListener('mousemove', columnMouseMoveHandler, false)
      document.removeEventListener('mouseup', columnMouseUpHandler, false)

      colSelector.classList.remove('selecting')

      console.log('Column Mouse Up Select')
      // console.log(index)
      // console.log(column)
      // console.log(column.style.width)

      let columnWidth = parseInt(column.style.width.replace('px', ''))

      let rowCount = 0
      let pageRows = 0

      article.pages.map((page, iPage, array) => {

        if (page.index === article.info.currentPage) {
          // console.log('CurrentPage: ' + article.info.currentPage)
          pageRows = page.rows
        }

        page.selected.map((selected, iSelected, innerArray) => {
          if (selected.column === index) {
            // console.log('Selected Item: ' + selected.column + ' ' + selected.row)
            rowCount++
          }
        })

        // console.log('RowCount: ' + rowCount)
        // console.log('Page Rows: ' + page.rows)
      })

      if (rowCount === pageRows) {
        actions.articleActions.removeSelectedColumn({
          index: article.info.currentPage,
          column: index,
          width: columnWidth
        })
      } else {
        actions.articleActions.addSelectedColumn({
          index: article.info.currentPage,
          column: index,
          width: columnWidth
        })
      }
    }

    colSelector.addEventListener('mousedown', colMouseDownHandler, false)
  }

  createSelectableRow = (currentPage, row, rowSelector, index) => {
    // console.log(row)
    // console.log(rowSelector)
    // console.log(index)
    // console.log(currentPage)

    let height = 0
    let mouseDown = 0
    let mouseMoved = 0

    // console.log(rowSelector)

    const rowMouseDownHandler = (event) => {
      mouseDown = event.clientY

      const styles = window.getComputedStyle(row)
      height = parseInt(styles.height, 10)

      document.addEventListener('mousemove', rowMouseMoveHandler, false)
      document.addEventListener('mouseup', rowMouseUpHandler, false)

      rowSelector.classList.add('selecting')

      // console.log('HERE')
      // console.log(rowSelector)

      console.log('Row Mouse Down Select')
    }

    const rowMouseMoveHandler = (event) => {
      // row.style.height = (height + (event.clientY - mouseDown)) + 'px'

      console.log('Row Mouse Up Select')
    }

    const rowMouseUpHandler = (event) => {
      const { article } = this.state

      document.removeEventListener('mousemove', rowMouseMoveHandler, false)
      document.removeEventListener('mouseup', rowMouseUpHandler, false)

      rowSelector.classList.remove('selecting')

      console.log('Row Mouse Up Select')
      // console.log(index)
      // console.log(row)
      // console.log(row.style.height)

      let rowHeight = parseInt(row.style.height.replace('px', ''))

      /* actions.articleActions.setHeight({
        index: article.info.currentPage,
        row: index,
        height: rowHeight
      }) */

      let columnCount = 0
      let pageColumn = 0

      article.pages.map((page, iPage, array) => {

        if (page.index === article.info.currentPage) {
          // console.log('CurrentPage: ' + article.info.currentPage)
          pageColumn = page.rows
        }

        page.selected.map((selected, iSelected, innerArray) => {
          if (selected.row === index) {
            // console.log('Selected Item: ' + selected.column + ' ' + selected.row)
            columnCount++
          }
        })

        // console.log('columnCount: ' + columnCount)
        // console.log('Page Rows: ' + page.rows)
      })

      if (columnCount === pageColumn) {
        actions.articleActions.removeSelectedRow({
          index: article.info.currentPage,
          row: index,
          height: rowHeight
        })
      } else {
        actions.articleActions.addSelectedRow({
          index: article.info.currentPage,
          row: index,
          height: rowHeight
        })
      }
    }

    rowSelector.addEventListener('mousedown', rowMouseDownHandler, false)
  }

  removeResizer = (previousPage) => {
    // console.log('removeResizer')
    // console.log(previousPage)

    const tables = document.getElementById('table')
    const columns = tables.querySelectorAll('th')
    const rows = tables.querySelectorAll('tr')

    columns.forEach((column, index, array) => {
      if (columns.length - 1 === index) {
        // return
      }

      let colResizerAlreadyExist = column.children.namedItem('colResizer' + previousPage + 'c' + index) ? true : false

      if (colResizerAlreadyExist) {
        // console.log(column.querySelector('colResizer' + previousPage + 'c' + index))
        column.removeChild(column.children.namedItem('colResizer' + previousPage + 'c' + index))
      }
    })

    rows.forEach((row, index, array) => {
      if (rows.length - 1 === index) {
        // return
      }

      let rowResizerParent = row.parentElement.parentElement.parentElement
      let rowResizerAlreadyExist = rowResizerParent.children.namedItem('rowResizer' + previousPage + 'r' + index) ? true : false

      if (rowResizerAlreadyExist) {
        // console.log(row.querySelector('rowResizer' + previousPage + 'r' + index))
        rowResizerParent.removeChild(rowResizerParent.children.namedItem('rowResizer' + previousPage + 'r' + index))
      }
    })
  }

  addResizer = () => {
    // console.log('addResizer')

    const { 
      article
    } = this.state

    let navigation = false
    let negativeNavigation = false
    let pageSelection = false
    let negativePageSelection = false
    let spacing = 0
    let spacingMargin = 0

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index ? navigation = page.activeNavigation : null
      article.info.currentPage === page.index ? negativeNavigation = page.activeNegativeNavigation : null
      article.info.currentPage === page.index ? pageSelection = page.activePageSelection : null
      article.info.currentPage === page.index ? negativePageSelection = page.activeNegativePageSelection : null
      article.info.currentPage === page.index ? spacing = page.spacing : null
      article.info.currentPage === page.index ? spacingMargin = page.spacingMargin : null
    })

    const tables = document.getElementById('table')
    const columns = tables.querySelectorAll('th')
    const rows = tables.querySelectorAll('tr')

    columns.forEach((column, index, array) => {

      if (columns.length - 1 === index) {
        return
      }

      let colResizerAlreadyExist = column.children.namedItem('colResizer' + article.info.currentPage + 'c' + index) ? true : false

      if (colResizerAlreadyExist) {
        // console.log(column.querySelector('colResizer' + article.info.currentPage + 'c' + index))
        column.removeChild(column.children.namedItem('colResizer' + article.info.currentPage + 'c' + index))
      }

      const colResizer = document.createElement('div')
      colResizer.classList.add('colResizer' + article.info.currentPage + 'c' + index)
      colResizer.id = 'colResizer' + article.info.currentPage + 'c' + index
      colResizer.style.height = navigation && negativeNavigation ? 'calc(100vh - ' + (columns.length * spacing) + 'px - 100px)' : navigation || negativeNavigation ? 'calc(100vh - ' + (columns.length * spacing) + 'px - 50px)' : 'calc(100vh - ' + (columns.length * spacing) + 'px)'
      colResizer.style.position = 'absolute'
      colResizer.style.top = '0'
      colResizer.style.right = '0'
      colResizer.style.width = '5px'
      colResizer.style.cursor = 'col-resize'
      colResizer.style.userSelect = 'none'
      colResizer.style.zIndex = '1'

      column.appendChild(colResizer)

      this.createResizeableColumn(column, colResizer, index)
    })

    rows.forEach((row, index, array) => {
      if (rows.length - 1 === index) {
        return
      }

      let rowResizerParent = row.parentElement.parentElement.parentElement
      let rowResizerPosition = row.getBoundingClientRect()

      let rowResizerPositionBottom = (rowResizerPosition.top + rowResizerPosition.height - 3) + 'px'
      let rowResizerPositionLeft = rowResizerPosition.left + 'px'
      let rowResizerPositionWidth = 0
      let rowResizerPositionHeight = '3px'

      // console.log('--- --- ---')
      // console.log(rowResizerPosition)
      // console.log(rowResizerPositionBottom)
      // console.log(rowResizerPositionLeft)
      // console.log(rowResizerPositionWidth)
      // console.log(rowResizerPositionHeight)

      let rowResizerAlreadyExist = rowResizerParent.children.namedItem('rowResizer' + article.info.currentPage + 'r' + index) ? true : false

      if (rowResizerAlreadyExist) {
        // console.log(row.querySelector('rowResizer' + article.info.currentPage + 'r' + index))
        rowResizerParent.removeChild(rowResizerParent.children.namedItem('rowResizer' + article.info.currentPage + 'r' + index))
      }

      const rowResizer = document.createElement('div')
      rowResizer.classList.add('rowResizer' + article.info.currentPage + 'r' + index)
      rowResizer.id = 'rowResizer' + article.info.currentPage + 'r' + index
      rowResizer.style.height = rowResizerPositionHeight
      rowResizer.style.position = 'absolute'
      // rowResizer.style.bottom = '0'
      rowResizer.style.top = rowResizerPositionBottom
      // rowResizer.style.left = '0'
      rowResizer.style.left = rowResizerPositionLeft
      rowResizer.style.width = spacingMargin && pageSelection && negativePageSelection ? 'calc(100vw - 100px)' : pageSelection && negativePageSelection ? 'calc(100vw - 100px)' : spacingMargin && pageSelection ? 'calc(100vw - 50px)' : spacingMargin && negativePageSelection ? 'calc(100vw - 50px)' : spacingMargin ? '100vw' : pageSelection ? 'calc(100vw - ' + (rows.length * spacing) + 'px - 50px)' : negativePageSelection ? 'calc(100vw - ' + (rows.length * spacing) + 'px - 50px)' : 'calc(100vw - ' + (rows.length * spacing) + 'px)'
      rowResizer.style.cursor = 'row-resize'
      rowResizer.style.userSelect = 'none'

      rowResizerParent.appendChild(rowResizer)

      this.createResizeableRow(row, rowResizer, index)
    })
  }

  createResizeableColumn = (column, colResizer, index) => {
    let width = 0
    let mouseDown = 0
    let mouseMoved = 0

    const colMouseDownHandler = (event) => {
      mouseDown = event.clientX

      const styles = window.getComputedStyle(column)
      width = parseInt(styles.width, 10)

      document.addEventListener('mousemove', columnMouseMoveHandler, false)
      document.addEventListener('mouseup', columnMouseUpHandler, false)

      colResizer.classList.add('resizing')

      console.log('Column Mouse Down Resize: ' + mouseDown)
    }

    const columnMouseMoveHandler = (event) => {
      column.style.width = (width + (event.clientX - mouseDown)) + 'px'

      console.log('Column Mouse Move Resize: ' + width + ' ' + event.clientX + ' ' + mouseDown)
      console.log('Column Mouse Move Resize: ' + (width + (event.clientX - mouseDown)) + 'px')
    }

    const columnMouseUpHandler = (event) => {
      const { article } = this.state

      document.removeEventListener('mousemove', columnMouseMoveHandler, false)
      document.removeEventListener('mouseup', columnMouseUpHandler, false)

      colResizer.classList.remove('resizing')

      // console.log('Column Mouse Up Resize')
      // console.log(index)
      // console.log(column)
      // console.log(column.style.width)

      let columnWidth = parseInt(column.style.width.replace('px', ''))

      actions.articleActions.setWidth({
        index: article.info.currentPage,
        column: index,
        width: columnWidth
      })
    }

    colResizer.addEventListener('mousedown', colMouseDownHandler, false)
  }

  createResizeableRow = (row, rowResizer, index) => {
    let height = 0
    let mouseDown = 0
    let mouseMoved = 0

    // console.log(rowResizer)

    const rowMouseDownHandler = (event) => {
      mouseDown = event.clientY

      const styles = window.getComputedStyle(row)
      height = parseInt(styles.height, 10)

      document.addEventListener('mousemove', rowMouseMoveHandler, false)
      document.addEventListener('mouseup', rowMouseUpHandler, false)

      rowResizer.classList.add('resizing')

      // console.log('HERE')
      // console.log(rowResizer)

      // console.log('Row Mouse Down Resize')
    }

    const rowMouseMoveHandler = (event) => {
      row.style.height = (height + (event.clientY - mouseDown)) + 'px'

      // console.log('Row Mouse Up Resize')
    }

    const rowMouseUpHandler = (event) => {
      const { article } = this.state

      document.removeEventListener('mousemove', rowMouseMoveHandler, false)
      document.removeEventListener('mouseup', rowMouseUpHandler, false)

      rowResizer.classList.remove('resizing')

      // console.log('Row Mouse Up Resize')
      // console.log(index)
      // console.log(row)
      // console.log(row.style.height)

      let rowHeight = parseInt(row.style.height.replace('px', ''))

      actions.articleActions.setHeight({
        index: article.info.currentPage,
        row: index,
        height: rowHeight
      })
    }

    rowResizer.addEventListener('mousedown', rowMouseDownHandler, false)
  }

  onMouseOver = (id, clickEvent) => {
    
  }

  onClicked = (id, clickEvent) => {
    
  }

  renderTable = () => {
    let { 
      article
    } = this.state

    let pageSelection = false
    let negativePageSelection = false
    let navigation = false
    let negativeNavigation = false
    let spacing = 1
    let spacingMargin = false
    let columns = 0
    let rows = 0

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index ? columns = page.columns : null
      article.info.currentPage === page.index ? rows = page.rows : null
    })

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index ? pageSelection = page.activePageSelection : null
      article.info.currentPage === page.index ? negativePageSelection = page.activeNegativePageSelection : null
      article.info.currentPage === page.index ? navigation = page.activeNavigation : null
      article.info.currentPage === page.index ? negativeNavigation = page.activeNegativeNavigation : null
      article.info.currentPage === page.index ? spacing = page.spacing : null
      article.info.currentPage === page.index ? spacingMargin = page.spacingMargin : null
    })

    // console.log('EditorTable - renderTable - pageSelection: ' + pageSelection)
    // console.log(pageSelection)
    // console.log('EditorTable - renderTable - navigation: ' + navigation)
    // console.log(navigation)
    // console.log('EditorTable - renderTable - spacing: ' + spacing)
    // console.log(spacing)
    // console.log('EditorTable - renderTable - spacingMargin: ' + spacingMargin)
    // console.log(spacingMargin)

    // console.log(rows)
    // console.log(columns)
    
    let renderableTable = []

    let vw = '100vw'
    let twspa = pageSelection && negativePageSelection ? (((columns + 1) * spacing) - 100) : pageSelection || negativePageSelection ? (((columns + 1) * spacing) - 50) : ((columns + 1) * spacing)
    let widthActive = 'calc(' + vw + ' + ' + twspa + 'px)'

    let twispa = pageSelection && negativePageSelection ? (spacing - 100) : pageSelection || negativePageSelection ? (spacing - 50) : spacing
    let widthInactive = 'calc(' + vw + ' + ' + twispa + 'px)'

    let marginActive = '0 0 0 -' + spacing + 'px'
    let marginInactive = '0 -' + spacing + 'px 0 0'

    let vh = navigation && negativeNavigation ? 'calc(100vh - 100px)' : navigation || negativeNavigation ? 'calc(100vh - 50px)' : '100vh'
    let thspa = spacing
    let heightActive = 'calc(' + vh + ' - ' + thspa + 'px)'

    let thispa = spacing
    let heightInactive = 'calc(' + vh + ' - ' + thispa + 'px)'

    // console.log('EditorTable - renderTable - pageSelection: ' + vw)
    // console.log('EditorTable - renderTable - twspa: ' + twspa)
    // console.log('EditorTable - renderTable - widthActive: ' + widthActive)
    // console.log('EditorTable - renderTable - twispa: ' + twispa)
    // console.log('EditorTable - renderTable - widthInactive: ' + widthInactive)
    // console.log('EditorTable - renderTable - marginActive: ' + marginActive)
    // console.log('EditorTable - renderTable - vh: ' + vh)
    // console.log('EditorTable - renderTable - thspa: ' + thspa)
    // console.log('EditorTable - renderTable - heightActive: ' + heightActive)
    // console.log('EditorTable - renderTable - thispa: ' + thispa)
    // console.log('EditorTable - renderTable - heightInactive: ' + heightInactive)

    // console.log('Preview')
    // console.log(article.preview)

    renderableTable.push(
      <table
        id={ 'table' }
        key={ 'templateTable' }
        style={{
          minWidth: spacingMargin ? widthActive : widthInactive,
          width: spacingMargin ? widthActive : widthInactive,
          maxWidth: spacingMargin ? widthActive : widthInactive,
          minHeight: vh, /* table.spacingMargin ? heightActive : heightInactive, */
          height: vh, /* table.spacingMargin ? heightActive : heightInactive, */
          maxHeight: vh, /* table.spacingMargin ? heightActive : heightInactive, */
          borderSpacing: spacing,
          margin: spacingMargin ? marginActive : marginInactive,
          padding: 0,
          backgroundColor: article.preview ? 'rgba(255, 255, 255, 255)' : 'rgba(90, 90, 90, 255)'
        }}
      >

        {
          this.renderTableComplete()
        }

      </table>
    )

    return renderableTable
  }

  renderTableComplete = () => {
    let tableComplete = []

    tableComplete.push(
      <thead
        style={{
          backgroundColor: 'rgba(255, 255, 255, 255)'
        }}
      >

        {
          this.renderTableHeader()
        }

      </thead>
    )

    tableComplete.push(
      <tbody
        style={{
          backgroundColor: 'rgba(255, 255, 255, 255)'
        }}
      >

        {
          this.renderTableBody()
        }         

      </tbody>
    )

    return tableComplete
  }

  renderTableHeader = () => {
    const { article } = this.state

    let tableHeader = []

    let htmlElement = 'th'

    /* CALC HOW MUCH ROW AND COL SPAN EXIST */

    let rowSpan = 1
    let colSpan = 1

    /* END */

    let pageColumns = 0
    let rowHeight

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index ? pageColumns = page.columns : null
      article.info.currentPage === page.index && page.height.map((item, innerIndex, array) => {
        item.row === 0 ? rowHeight = item.height + 'px' : null

        if (innerIndex > 0) {
          return
        }

        tableHeader.push(
          <tr
            style={{
              position: 'relative',
              height: rowHeight
            }}
          >

            {
              page.width.map((innerItem, innerInnerIndex, array) => {
                // console.log('InnerIndex: ' + innerInnerIndex)
                // console.log('Column: ' + innerItem.column)
                // console.log('Width: ' + innerItem.width)

                return this.renderElement(innerIndex, innerItem.column, rowSpan, colSpan, htmlElement)
              })
            }

          </tr>
        )
      })
    })

    // console.log('Row Height: ' + rowHeight)

    return tableHeader
  }

  renderTableBody = () => {
    const { article } = this.state

    let tableBody = []
    let htmlElement = 'td'

    /* CALC HOW MUCH ROW AND COL SPAN EXIST */

    let rowSpan = 1
    let colSpan = 1

    /* END */

    let rowHeight

    /*article.pages.map((page, index, array) => {
      article.info.currentPage === page.index && page.height.map((item, index, array) => {
        item.row === 0 ? rowHeight = item.height + 'px' : null
      })
    })*/

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index && page.height.map((item, innerIndex, array) => {
        // console.log('Index: ' + innerIndex)
        // console.log('Row: ' + item.row)
        // console.log('Height: ' + item.height)
        item.row === 0 ? rowHeight = item.height + 'px' : null

        if (innerIndex == 0) {
          return
        }

        tableBody.push(
          <tr
            style={{
              position: 'relative'
            }}
          >

            {
              page.width.map((innerItem, innerInnerIndex, array) => {
                // console.log('InnerIndex: ' + innerInnerIndex)
                // console.log('Column: ' + innerItem.column)
                // console.log('Width: ' + innerItem.width)
                return this.renderElement(innerIndex, innerItem.column, rowSpan, colSpan, htmlElement)
              })
            }
            
          </tr>
        )
      })

      /*if (article.info.currentPage === page.index) {
        Array.from(Array(page.rows - 1), (row, rowIndex) => {
          console.log(row, rowIndex)
          tableBody.push(
            <tr
              style={{
                position: 'relative',
                height: rowHeight
              }}
            >

              {
                Array.from(Array(page.columns), (column, columnIndex) => {
                  return this.renderElement(rowIndex, columnIndex, rowSpan, colSpan, htmlElement)
                })
              }
              
            </tr>
          )
        })
      }*/
    })

    return tableBody
  }

  renderRows = () => {
    const { article } = this.state

    let rows = []

    for (let i = 0; i < (article.rows - 1); i++) {
      rows.push(
        <tr
          style={{
            position: 'relative'
          }}
          key={ i }
        >

          {
            this.renderElement(i, i, 1, 1, i) // REWORK
          }

       </tr>
      )
    }

    return rows
  }

  renderElement = (row, column, rowSpan, colSpan, htmlElement) => {
    const { 
      article,
      navigation,
      menu
    } = this.state

    let data = []

    // console.log('renderElement')
    // console.log('Row: ' + row + ' Column: ' + column)
    // console.log('RowSpan: ' + rowSpan)
    // console.log('ColSpan: ' + colSpan)
    // console.log('HTMLElement: ' + htmlElement)

    let columnWidth

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index && page.width.map((item, index, array) => {
        item.column === column && index != array.length - 1 ? columnWidth = item.width + 'px' : null
        // item.column === column ? console.log('CurrentPage: ' + article.info.currentPage + ' ' + index + ' ' + item.width + 'px ' + array.length) : null
      })
    })

    {
      htmlElement === 'th' ? (
        data.push(
          <th
            style={{
              position: 'relative',
              width: columnWidth
            }}
            rowSpan={ rowSpan }
            colSpan={ colSpan }
            key={ 'row' + row + 'column' + column }
            id={ 'p' + article.info.currentPage + 'r' + row + 'c' + column }
          >
            <EditorMedia
              article={ article }
              menu={ menu }
              navigation={ navigation }
              row={ row }
              column={ column }
              rowSpan={ rowSpan }
              colSpan={ colSpan }
            />
          </th>
        )
      ) : (
        data.push(
          <td
            style={{
              position: 'relative',
              // width: columnWidth
            }}
            rowSpan={ rowSpan }
            colSpan={ colSpan }
            key={ 'row' + row + 'column' + column }
            id={ 'p' + article.info.currentPage + 'r' + row + 'c' + column }
          >
            <EditorMedia
              article={ article }
              menu={ menu }
              navigation={ navigation }
              row={ row }
              column={ column }
              rowSpan={ rowSpan }
              colSpan={ colSpan }
            />
          </td>
        )
      )
    }

    // console.log(data)

    return data
  }

  render() {
    const { 
      article
    } = this.state

    // console.log('Render - CurrentPage: ' + article.info.currentPage)

    let activeNavigation = false
    let activePageSelection = false

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index ? activePageSelection = page.activePageSelection : null
      article.info.currentPage === page.index ? activeNavigation = page.activeNavigation : null
    })

    return (
      <div
        className="EditorTable"
        style={{
          padding: activeNavigation && activePageSelection ? '50px 0 0 50px' : activeNavigation ? '50px 0 0 0' : activePageSelection ? '0 0 0 50px' : '0'
        }}
      >
        {
          this.renderTable()
        }
      </div>
    );
  }
}

export default EditorTable;